import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getPrescription } from '../../services/patient.services';
import { capitalizeFirstLetter, formateDate } from '../../../../utils/commonfunction';
import { useTranslation } from 'react-i18next';
import { MEDICINE_OPTIONS } from '../../../../utils/Constants';

export default function PrescriptionView() {
    const { t } = useTranslation()
    const params = useParams();
    const [prescriptionData, setPrescriptionData] = useState({});
    const navigate = useNavigate();


    useEffect(() => {
        getPrescription({ appointment_id: params?.id })
            .then((response) => {
                setPrescriptionData(response?.data);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);


    return (
        <main id="main-content" className="mt-4">
            <div className='ms-3 me-3'>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card p-4 mb-4 card-info">
                            <div className='table-div-info mt-4'>

                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Doctor Name</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData?.doctor_name) ?? "-"}</p></div>
                                </div>

                                {prescriptionData?.diagnosis_notes && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Diagnosis</p></div>
                                        <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData.diagnosis_notes)}</p></div>
                                    </div>
                                )}

                                {/* {prescriptionData?.symptoms && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Chief Complaint</p></div>
                                        <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData.symptoms)}</p></div>
                                    </div>
                                )} */}
                                {prescriptionData?.symptoms && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'>
                                            <p className='m-0'>Chief Complaint</p>
                                        </div>
                                        <div className='table-div-info-item'>
                                            <p className='m-0'>
                                                {prescriptionData.symptoms.map(item => item.name).join(', ')}
                                            </p>
                                        </div>
                                    </div>
                                )}


                                {prescriptionData?.past_medical_history && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Past Medical History</p></div>
                                        <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData.past_medical_history)}</p></div>
                                    </div>
                                )}

                                {/* {prescriptionData?.investigation_advise && (
                            <div className='table-div-info-row'>
                                <div className='table-div-info-item'><p className='m-0'>Investigation Advise</p></div>
                                <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData.investigation_advise)}</p></div>
                            </div>
                        )} */}

                                {prescriptionData?.follow_up_date && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Follow-up Date</p></div>
                                        <div className='table-div-info-item'><p className='m-0'>{formateDate(prescriptionData.follow_up_date)}</p></div>
                                    </div>
                                )}

                                {prescriptionData?.test_name && (
                                    <div className='table-div-info-row'>
                                        <div className='table-div-info-item'><p className='m-0'>Diagnosis Test</p></div>
                                        <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(prescriptionData.test_name)}</p></div>
                                    </div>
                                )}
                            </div>

                            {/* Exercise Table */}
                            {/* {prescriptionData?.exercises?.length > 0 && (
                        <div className="mt-4">
                            <h5>Exercise</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Workout Category</th>
                                            <th className="text-center">Workout Time</th>
                                            <th className="text-center">Workout Duration</th>
                                            <th className="text-center">Workout Plan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {prescriptionData.exercises.map((exe, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{exe?.workout_category}</td>
                                                <td className="text-center">{extractTime(exe?.workout_time)}</td>
                                                <td className="text-center">{exe?.workout_duration} Minutes</td>
                                                <td className="text-center">{exe?.workout_plan}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )} */}

                            {/* Medicines Table */}
                            {prescriptionData?.medicines?.length > 0 && (
                                <div className="mt-4">
                                    <h3>Medicines</h3>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>Medicine Name</th>
                                                    <th className="text-center">Dosage</th>
                                                    {/* <th className="text-center">Frequency</th> */}
                                                    <th className="text-center">Start Date</th>
                                                    <th className="text-center">End Date</th>
                                                    <th className="text-center">Dosage(Times)</th>
                                                    <th className='text-center'>Instructions</th>
                                                    <th className="text-center">Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {prescriptionData.medicines.map((medicine) => (
                                                    <React.Fragment key={medicine?.medicine?.name}>
                                                        <tr>
                                                            {/* <td>{capitalizeFirstLetter(medicine.medicine_id ? medicine.medicine.name : medicine.medicine_name)}</td> */}
                                                            <td>{capitalizeFirstLetter(medicine.medicine.name)}</td>
                                                            <td className="text-center">{medicine?.dosage}</td>
                                                            {/* <td className="text-center">{medicine?.frequency}</td> */}
                                                            <td className="text-center">{formateDate(medicine?.start_date)}</td>
                                                            <td className="text-center">{formateDate(medicine?.end_date)}</td>
                                                            <td className="text-center">
                                                                {medicine.notification_times?.length > 0 ? medicine.notification_times.join(", ") : "-"}
                                                            </td>
                                                            <td className='text-center'>{medicine?.meal_time ? MEDICINE_OPTIONS.find((option) => option.value === medicine.meal_time)?.label : "-"}</td>
                                                            <td className="text-center">{medicine?.remarks ? capitalizeFirstLetter(medicine?.remarks) : "-"}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                                {prescriptionData?.medicine_note && (
                                                    <tr>
                                                        <td colSpan="6">
                                                            <strong>Medicine Note:</strong> {capitalizeFirstLetter(prescriptionData?.medicine_note)}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            <div className='card-info-action'>
                                <button className="btn btn-primary mt-4"
                                    onClick={() => {
                                        navigate(`/doctor/consultation-history/view/${params?.id}`);
                                    }}>
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>


    )
}
